var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.916 11.6668C11.8365 11.6668 12.5827 10.9206 12.5827 10.0002C12.5827 9.07969 11.8365 8.3335 10.916 8.3335C9.99554 8.3335 9.24935 9.07969 9.24935 10.0002C9.24935 10.9206 9.99554 11.6668 10.916 11.6668Z",
    fill: "#1990FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4993 11.6668C16.4198 11.6668 17.166 10.9206 17.166 10.0002C17.166 9.07969 16.4198 8.3335 15.4993 8.3335C14.5789 8.3335 13.8327 9.07969 13.8327 10.0002C13.8327 10.9206 14.5789 11.6668 15.4993 11.6668Z",
    fill: "#1990FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33268 11.6668C7.25316 11.6668 7.99935 10.9206 7.99935 10.0002C7.99935 9.07969 7.25316 8.3335 6.33268 8.3335C5.41221 8.3335 4.66602 9.07969 4.66602 10.0002C4.66602 10.9206 5.41221 11.6668 6.33268 11.6668Z",
    fill: "#1990FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.7a48b8a316035df27064d2c20e4b415b.svg";
export { ForwardRef as ReactComponent };